var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#894CF5",
    d: "M9.793 9.894h1.18v1.184h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.76 8.742c-.404 0-.793-.11-1.13-.313a2.193 2.193 0 0 1-2.26 0 2.193 2.193 0 0 1-2.259 0 2.193 2.193 0 0 1-1.67.246v4.541c0 .706.58 1.28 1.293 1.28h7.532c.713 0 1.293-.574 1.293-1.28V8.675a2.199 2.199 0 0 1-1.67-.246 2.193 2.193 0 0 1-1.13.313z",
    fill: "#FA7977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 11.202 8.206 12.3l1.994-2",
    stroke: "#FFF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76 7.826V5.807H2.5v.771c0 .809.664 1.467 1.481 1.467.286 0 .552-.08.778-.22zM13.992 3.65c-.186-.645-.862-1.15-1.538-1.15H4.546c-.676 0-1.352.505-1.538 1.15l-.422 1.46h11.828l-.422-1.46zM6.24 8.045c.286 0 .553-.08.779-.22V5.808H5.463v2.019c.226.139.492.22.778.22zM12.24 5.807v2.019c.227.139.493.22.779.22.817 0 1.481-.659 1.481-1.468v-.77h-2.26zM8.5 8.045c.285 0 .552-.08.778-.22V5.808H7.722v2.019c.226.139.493.22.778.22zM10.76 8.045c.285 0 .551-.08.777-.22V5.808H9.981v2.019c.226.139.493.22.778.22z",
    fill: "#FFB8B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShopIcon);
export default __webpack_public_path__ + "static/media/ic_shop_icon.9e8de5ee9fa76fcb20fae480d2276271.svg";
export { ForwardRef as ReactComponent };